import React from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router';
import { isAuthenticated } from '../helpers/session';

type Props = {
  component?: any;
  rest?: any;
};
const PrivateRoute = ({ component: Component, ...rest }: Props) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default PrivateRoute;
